import CustomSchedulerItem from "@/components/kendo/scheduler/custom-scheduler-item";

export default function CustomSchedulerItemMonth(props: any) {
    return CustomSchedulerItem({ ...props, monthView: true });
}